export default __webpack_public_path__ + "static/og-share-e27b9b13db912ea0ff5dfd6edb6c6f47.png";